export default "__VITE_ASSET__0d052e83__"